import {useCallback, useEffect, useRef} from "react";
import axios, {CancelTokenSource} from "axios";

const useCancelTokenSource = ({ cancelMessage } : { cancelMessage: string }) => {
    const source = useRef<CancelTokenSource>();

    const createSource = useCallback(() => {
        source.current = axios.CancelToken.source();
        return source.current;
    }, []);

    const cancelPreviousRequest = (message?:string) : void => {
        if (source.current) source.current.cancel(message);
    }

    useEffect(() => cancelPreviousRequest(cancelMessage), [cancelMessage]);

    return { source: source.current, createSource, cancelPreviousRequest };
}

export default useCancelTokenSource;
